/** The orders module's part of the vendor dashboard (`dashboard.tiles` slot): the store's sales, orders, earnings. */

import { useQuery } from "@tanstack/react-query";

import { vendorOrdersSummary } from "@motolynk/api-client";
import { useTranslation } from "@motolynk/i18n";
import { formatMoney, KpiTile } from "@motolynk/ui";

function useSummary() {
  return useQuery({
    queryKey: ["vendor", "orders", "summary"],
    queryFn: async () => (await vendorOrdersSummary()).data,
  });
}

export function StoreSalesTile() {
  const { t } = useTranslation("orders");
  const summary = useSummary().data;
  return (
    <KpiTile
      tone="dark"
      icon="trending"
      label={t("dashboard.sales")}
      value={summary ? formatMoney(summary.sales_today) : "—"}
    />
  );
}

export function StoreOrdersTile() {
  const { t } = useTranslation("orders");
  const summary = useSummary().data;
  return (
    <KpiTile
      icon="cart"
      label={t("dashboard.orders")}
      value={summary ? summary.orders_today : "—"}
      hint={summary ? t("dashboard.toConfirm", { count: summary.new_orders }) : undefined}
    />
  );
}

export function StoreEarningsTile() {
  const { t } = useTranslation("orders");
  const summary = useSummary().data;
  return (
    <KpiTile
      icon="wallet"
      label={t("dashboard.earnings")}
      value={summary ? formatMoney(summary.payable) : "—"}
      hint={t("dashboard.earningsHint")}
    />
  );
}
